export * from "./lib/search-provider";

const ALGOLIA_INDEX_PREFIX = import.meta.env["VITE_ALGOLIA_INDEX_PREFIX"];

export function getAlgoliaIndexName() {
  return `${String(ALGOLIA_INDEX_PREFIX)}tudigo_projects_fr` as const;
}
